import { message } from 'antd';
import TcFormButtons from 'components/UI/FormButtons/TcFormButtons';
import TcModal from 'components/UI/Modal/TcModal';
import TcInput from 'components/UI/form/input/TcInput';
import { packageCreate } from 'global/Models/omOrderModel';
import { packagingCreate } from 'global/Models/packagingModel';
import { separator } from 'global/default';
import { englishNumberOnly } from 'global/helperFunctions/default';
import { FC, useEffect, useState } from 'react';
import { FaHandHoldingUsd } from 'react-icons/fa';
import { GoPackage } from 'react-icons/go';

interface IOrderCODItemPrice {
  packaging: packagingCreate;
  setPackages: React.Dispatch<React.SetStateAction<packageCreate[]>>;
  packageIndex: number;
  packagingIndex: number;
}

const OrderCODItemPrice: FC<IOrderCODItemPrice> = ({ packaging, setPackages, packageIndex, packagingIndex }) => {
  //states
  const [showModal, setShowModal] = useState<boolean>(false);
  const [inputNumber, setInputNumber] = useState<number>(packaging.cod || packaging.price);

  //effect
  useEffect(() => {
    setInputNumber(packaging.cod || packaging.price);
  }, [packaging.cod]);

  //functions
  const toggleShowModal = () => setShowModal(!showModal);
  const handleSubmit = (customPrice: number) => {
    if (customPrice > packaging.price) return message.error('مبلغ دریافتی نمی تواند از ارزش کالا بیشتر باشد.');
    if (!customPrice) return message.error('مبلغ دریافتی نمی تواند خالی باشد.');
    setPackages((prevState) => {
      const newState = [...prevState];
      newState[packageIndex].package[packagingIndex].cod = customPrice;
      return newState;
    });
    return setShowModal(false);
  };

  return (
    <div className='flex justify-between w-full gap-4 p-2 rounded-lg bg-t-layer-bg-color-hovered'>
      <div>
        <span className='flex items-center text-xs color-inherit text-t-secondary-text-color'>
          <GoPackage className='ml-1' />
          بسته :
        </span>
        <div className='flex flex-col'>
          <span className='text-xs font-medium'>{packaging.title}</span>
          <span className='flex mt-2 text-xs font-medium text-t-secondary-text-color inherit-color'>
            <FaHandHoldingUsd className='ml-1' />
            مبلغ دریافتی :{' '}
          </span>
          <div className='flex items-center gap-2'>
            <span className='text-sm font-medium'>{packaging.count || 1}</span>
            <span className='text-sm font-medium'>x</span>
            <span className='text-sm font-medium'>{separator(packaging.cod || packaging.price)} ریال</span>
            <span className='text-xs font-medium cursor-pointer text-t-secondary-color' onClick={toggleShowModal}>
              تغییر
            </span>
            {!!packaging.cod && packaging.cod != packaging.price && (
              <span className='text-xs font-medium cursor-pointer text-t-secondary-color' onClick={() => handleSubmit(packaging.price)}>
                دریافت ارزش کالا
              </span>
            )}
          </div>
        </div>
      </div>
      {/* <div>
        <span className='flex items-center text-xs color-inherit text-t-secondary-text-color'>
          <FaHandHoldingUsd className='ml-1' />
          هزینه دریافتی :
        </span>
        <div className='flex flex-col'>
          {isCodChanged ? <span className='text-sm'>دریافت کل ارزش کالا از گیرنده</span> : <span className='text-sm'>{separator(packaging.cod)} ریال</span>}
          <span className='text-sm cursor-pointer text-t-secondary-color' onClick={toggleShowModal}>
            تغییر
          </span>
        </div>
      </div> */}
      <TcModal visible={showModal} title='تعیین مبلغ دریافتی' onCancel={toggleShowModal} footer={false}>
        <p className='text-xs'>
          شما می توانید تنها بخشی از مبلغ ارزش کالا را از گیرنده دریافت کنید.
          <br />
          برای این کار مبلغ مورد نظر را در کادر زیر وارد کنید.
          <br />
          در صورتی که مبلغ وارد نشود، مبلغ کل ارزش کالا از گیرنده دریافت می شود.
          <br />
          توجه داشته باشید که مبلغ دریافتی نمی تواند از ارزش کالا بیشتر باشد.
        </p>
        <p className='mt-6 mb-1'>تعیین مبلغ دریافتی به ازای هر {packaging.title} :</p>
        <div className='flex items-center gap-2 mb-6'>
          <span>{packaging.count || 1}</span>
          <span>X</span>
          <TcInput className='w-full' value={inputNumber} onChange={(e) => setInputNumber(englishNumberOnly(e.target.value))} />
          <span>ریال</span>
        </div>
        <div className='flex flex-col items-end'>
          <small>
            ارزش کالا <b>{separator(packaging.price)}</b> ریال
          </small>
          <small>
            دریافت مبلغ <b className={`${inputNumber > packaging.price && 'text-t-error-color'}`}>{separator(inputNumber)}</b> ریال به ازای هر بسته
          </small>
        </div>
        <TcFormButtons submitButtonText='ثبت' onSubmit={() => handleSubmit(inputNumber)} cancelButtonText='بازگشت' onCancel={toggleShowModal} />
      </TcModal>
    </div>
  );
};

export default OrderCODItemPrice;
